import { EmailFilterStatus } from '@webapp/account/src/resources/mailing/email-detail';

export interface MailFilters {
    status: EmailFilterStatus;
    startDatetime: string;
}

export const initialFilters: Readonly<MailFilters> = {
    status: EmailFilterStatus.ALL,
    startDatetime: '',
};
